<template>
  <div class="d-flex flex-column h-100">
    <div class="d-flex flex-wrap pr-3 pl-3">
      <!-- <div v-if="!foreignСompany">
          v-model="daDataSearch"
      </div> -->

      <form class="mb-1">
        <div class="mb-4 d-flex justify-content-space-between align-items-center">
            <h5 class="mb-0 pb-0">Основная информация</h5>
            <div class="d-flex align-items-center">
                <b-form-checkbox
                    name="check-button"
                    v-if="!isAgent"
                    v-model="editedItemLocal.is_b2c_rezident"
                    switch
                >
                    Резидент B2C
                </b-form-checkbox>
                <div v-if="!isAgent && editedItemLocal.is_b2c_rezident" class="form-group ml-3 mb-0">
                    <b-form-input
                        id="b2c_alias"
                        v-model="editedItemLocal.b2c_alias"
                        size="sm"
                        placeholder="Краткое имя: Ozon, WB..."
                        style="max-width: 10rem;"
                    ></b-form-input>
                </div>
                <b-form-checkbox
                    name="check-button"
                    class="ml-3"
                    v-model="foreignСompany"
                    switch
                >
                    Иностранная компания
                </b-form-checkbox>
            </div>
        </div>

        <div class="form-row">
          <div class="form-group col-md-4">
            <label for="inputNameCompany">Название компании</label>
            <input v-model="editedItemLocal.name" type="text" class="form-control" id="inputNameCompany">
            <div class="invalid-feedback d-block">
              {{ validateCompanyName.errorText }}
            </div>
          </div>
          <div class="form-group col-md-4">
            <label for="inputTypeCompany">Юридическое лицо</label>
            <b-form-select v-model="editedItemLocal.type" :options="typeList"></b-form-select>
          </div>
          <div class="form-group col-md-4">
            <label for="reference_company_status_id">Статус</label>
            <company-client-status-field
              :statusId="editedItemLocal.reference_company_status_id"
              :statusName="editedItemLocal.status ? editedItemLocal.status.name : ''"
              :isAtRisk="editedItemLocal.is_at_risk"
              @set-status="setStatusOfCompany"
              @set-risk="setRiskOfCompany"
            ></company-client-status-field>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-4">
            <label>Источник</label>
            <tsoft-select-of-properties
              :reference_id="4"
              :needNullElement="true"
              :disabled="isAgent || editedItemLocal.creator_user_id == editedItemLocal.sales_manager_user_id"
              :selected="editedItemLocal.reference_sources_id"
              :excludeArray="[
                895,319,537
              ]"
              @set="setSourceOfCompany"
            ></tsoft-select-of-properties>
          </div>
          <div class="form-group col-md-4" v-if="isAgent">
            <label>Сезонность</label>
            <b-form-select 
              v-model="editedItemLocal.seasonable"  
              :options="seasonable"
              value-field="value"
              text-field="name"
            >
              <b-form-select-option :value="null">Не сезонная</b-form-select-option>
            </b-form-select>
          </div>          
          <div class="form-group col-md-4" v-if="!isAgent">
            <label>Тип компании</label>
            <tsoft-select-of-properties
              :reference_id="41"
              :needNullElement="true"
              :selected="editedItemLocal.reference_friend_type_id"
              @set="setFriendTypeOfCompany"
            ></tsoft-select-of-properties>
          </div>
          <div class="form-group col-md-4" v-if="editedItemLocal.reference_friend_type_id != 412">
            <label>Статус продаж</label>
            <b-form-select v-model="editedItemLocal.sales_status" :options="salesStatusList"></b-form-select>
            
            <div class="form-group mt-3" v-if="editedItemLocal.sales_status == 'Не готов'">
              <label for="reference_company_status_id">Причина отказа</label>
              <tsoft-select-of-properties
                :reference_id="74"
                :needNullElement="true"
                :needMultipleSelect="false"
                :defaultSelectName="`Выберите причину`"
                :internalSearch="false"
                :selected="editedItemLocal.decline_type_reference_property_id"
                @set="setDeclineTypeOfCompany"
              ></tsoft-select-of-properties>
            </div>

          </div>
          <div class="form-group col-md-4" v-if="editedItemLocal.reference_friend_type_id == 412">
            <label>&nbsp;</label>
            <b-form-checkbox
              name="check-button"
              class="ml-2 mt-2 pt-1"
              v-model="editedItemLocal.is_transport_company"
              switch
            >
              Транспортная компания
            </b-form-checkbox>
          </div>            
        </div>
        <template v-if="editedItemLocal.is_transport_company">
          <div class="form-row">
            <div class="form-group col-md-4">
              <label for="type_of_transport_company">Тип поставщика</label>
              <b-form-select 
                v-model="editedItemLocal.type_of_transport_company"
                :options="typeOfTransportCompanyList"
              ></b-form-select>
            </div>
            <div class="form-group col-md-8 corrected-multiselect__tags">
              <label>Сегменты услуг компании</label>
              <tsoft-select-of-properties
                key="set_services_ids"
                :reference_id="86"
                :needNullElement="false"
                :needMultipleSelect="true"
                :defaultSelectName="``"
                :selectedArray="editedItemLocal.set_services_ids"
                @set="setServicesOfCompany"
              ></tsoft-select-of-properties>
            </div>
            <div class="form-group col-md-12 corrected-multiselect__tags">
              <label>Специальные возможности</label>
              <tsoft-select-of-properties
                key="set_special_features_ids"
                :reference_id="82"
                :needNullElement="false"
                :needMultipleSelect="true"
                :defaultSelectName="``"
                :selectedArray="editedItemLocal.set_special_features_ids"
                @set="setSpecialFeaturesOfCompany"
              ></tsoft-select-of-properties>
            </div>              
            <div class="form-group col-md-6 corrected-multiselect__tags">
              <label>Страны регистрации филиалов и <br>обособленных подразделений</label>
              <tsoft-select-of-properties
                :key="`set_countries_of_branches_ids_${refreshers['set_countries_of_branches_ids']}`"
                :reference_id="20"
                :needNullElement="false"
                :needMultipleSelect="true"
                :defaultSelectName="``"
                :selectedArray="editedItemLocal.set_countries_of_branches_ids"
                @set="setCountriesOfBranchesOfCompany"
              ></tsoft-select-of-properties>

              <div class="region-buttons" style="top: 19px;">
                <button
                  v-for="(countries, region) in regions"
                  :key="region"
                  class="btn btn-outline-secondary btn-sm mr-1"
                  @click.prevent="selectRegionCountries(countries, 'set_countries_of_branches_ids')"
                >
                  {{ region }}
                </button>
              </div>              
            </div>              
            <div class="form-group col-md-6 corrected-multiselect__tags">
              <label>Страны регистрации собственного <br>подвижного состава</label>
              <tsoft-select-of-properties
                :key="`set_countries_of_rolling_stock_ids_${refreshers['set_countries_of_rolling_stock_ids']}`"
                :reference_id="20"
                :needNullElement="false"
                :needMultipleSelect="true"
                :defaultSelectName="``"
                :selectedArray="editedItemLocal.set_countries_of_rolling_stock_ids"
                @set="setCountriesOfRollingStocksOfCompany"
              ></tsoft-select-of-properties>

              <div class="region-buttons" style="top: 19px;">
                <button
                  v-for="(countries, region) in regions"
                  :key="region"
                  class="btn btn-outline-secondary btn-sm mr-1"
                  @click.prevent="selectRegionCountries(countries, 'set_countries_of_rolling_stock_ids')"
                >
                  {{ region }}
                </button>
              </div>              
            </div>              
          </div>
        </template>
        <template v-if="!editedItemLocal.is_transport_company && !isAgent">
          <div class="form-row">
            <div class="form-group col-md-4">
              <label>Менеджер SALES</label>
              <tsoft-select-user
                id="sales_manager_user_id"
                :roles="`sales-manager||sales-head-manager||logistics-manager||logistics-head-manager||logistics-multim-manager||logistics-multim-head-manager||TO-manager||TO-head-manager||president||bsz-manager||b2c-head-manager||b2c-manager||agent`"
                :needNullElement="true"
                :selected="editedItemLocal.sales_manager_user_id"
                @set="setSalesManagerOfCompany"
              ></tsoft-select-user>
            </div>
            <div class="form-group col-md-4">
              <label>Менеджер по ведению ВЭД</label>
              <tsoft-select-user
                id="to_manager_user_id"
                :roles="`sales-manager||sales-head-manager||logistics-manager||logistics-head-manager||logistics-multim-manager||logistics-multim-head-manager||TO-manager||TO-head-manager||president||bsz-manager||b2c-head-manager||b2c-manager`"
                :needNullElement="true"
                :selected="editedItemLocal.to_manager_user_id"
                @set="setTOManagerOfCompany"
              ></tsoft-select-user>
            </div>
            <div class="form-group col-md-4">
              <label>Менеджер по ведению ТЭО</label>
              <tsoft-select-user
                id="teo_manager_user_id"
                :roles="`sales-manager||sales-head-manager||logistics-manager||logistics-head-manager||logistics-multim-manager||logistics-multim-head-manager||TO-manager||TO-head-manager||president||bsz-manager||b2c-head-manager||b2c-manager`"
                :needNullElement="true"
                :selected="editedItemLocal.teo_manager_user_id"
                @set="setTEOManagerOfCompany"
              ></tsoft-select-user>
            </div>
          </div>
          <div class="form-row" v-if="!isAgent">
            <div class="form-group col-md-4">
              <label>Сезонность</label>
              <b-form-select 
                v-model="editedItemLocal.seasonable"  
                :options="seasonable"
                value-field="value"
                text-field="name"
              >
                <b-form-select-option :value="null">Не сезонная</b-form-select-option>
              </b-form-select>
            </div>               
          </div>
        </template>
        <template v-if="!editedItemLocal.is_transport_company && !isAgent">
          <h5 class="my-4">Привязка к учётке клиента</h5>
          <div>
            <div class="form-row" v-for="(client, index) in editedItemLocal.clients" :key="index">
              <div class="form-group col-md-4">
                <label>Клиент #{{ index + 1 }}</label>
                <div class="d-flex">
                  <div style="width: 295px">
                    <tsoft-select-user
                      :id="`client_user_id_${index}`"
                      :roles="`client`"
                      :needNullElement="true"
                      :selected="client.id"
                      style="width: 295px;"
                      @set="setClientOfCompany(index, $event)"
                    ></tsoft-select-user>
                  </div>
                  <button 
                    class="btn btn-outline-secondary ml-3" 
                    style="height: 47px; line-height: 47px;"
                    @click.prevent="removeClient(index)">Убрать<i class="far fa-trash-alt ml-2"></i>
                  </button>
                </div>
              </div>
            </div>
            <button  
                class="btn btn-outline-secondary" 
                style="height: 47px; line-height: 47px;"
                @click.prevent="addClient()"
              >Добавить клиента <i class="fas fa-plus ml-1"></i></button>
          </div>
        </template>  
        <h5 class="my-4">Реквизиты компании</h5>
        <div class="form-row">
          <div class="form-group col-md-4">
            <label for="inputInnCompany">ИНН</label>
            <input
              v-model="editedItemLocal.inn"
              @input="!foreignСompany ? maxCharsLimit(12, 'inn', 'editedItemLocal') : ''"
              ref="inn"
              type="text"
              class="form-control"
              id="inputInnCompany"
            >
          </div>
          <div class="form-group col-md-4" v-if="!foreignСompany">
            <label for="inputKppCompany">КПП</label>
            <input
              v-model="editedItemLocal.kpp"
              @input="!foreignСompany ? maxCharsLimit(9, 'kpp', 'editedItemLocal') : ''"
              type="text"
              class="form-control"
              id="inputKppCompany"
            >
          </div>
          <div class="form-group col-md-4" v-if="!foreignСompany">
            <label for="inputOgrnCompany">ОГРН</label>
            <input
              v-model="editedItemLocal.ogrn"
              @input="!foreignСompany ? maxCharsLimit(15, 'ogrn', 'editedItemLocal') : ''"
              type="text"
              class="form-control"
              id="inputOgrnCompany"
            >
          </div>
          <div class="form-group col-md-4">
            <label for="inputAddressCompany">Юридический адрес</label>
            <input v-model="editedItemLocal.address" type="text" class="form-control" id="inputAddressCompany">
          </div>
          <div class="form-group col-md-4" v-if="!foreignСompany">
            <label for="inputDirectorCompany">ФИО директора</label>
            <input v-model="editedItemLocal.director" type="text" class="form-control" id="inputDirectorCompany">
          </div>
          <div class="form-group col-md-4" v-if="!foreignСompany">
            <label for="inputTypeDirectorCompany">В лице</label>
            <input v-model="editedItemLocal.type_director" type="text" class="form-control" id="inputTypeDirectorCompany">
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-4">
            <label for="inputAddressFactCompany">Фактический адрес</label>
            <input v-model="editedItemLocal.address_fact" type="text" class="form-control" id="inputAddressFactCompany">
          </div>
          <div class="form-group col-md-4">
            <label for="date_of_opening">Дата основания компании</label>
            <input v-model="editedItemLocal.date_of_opening" type="date" class="form-control" id="date_of_opening">
          </div>
          <div class="form-group col-md-4" v-if="editedItemLocal.is_transport_company">
            <label for="year_certificate_of_residency">Справка о резидентстве (актуальный год)</label>
            <input v-model="editedItemLocal.year_certificate_of_residency" type="number" class="form-control" id="year_certificate_of_residency">
          </div>
        </div>

        <template v-if="editedItemLocal.is_transport_company">
          <h5 class="my-4">География деятельности компании</h5>
          <div class="form-row">
            <div class="form-group col-md-6 corrected-multiselect__tags">
              <label for="set_uploading_geography_ids">Страны загрузки</label>
              <tsoft-select-of-properties
                :key="`set_uploading_geography_ids_${refreshers['set_uploading_geography_ids']}`"
                :reference_id="20"
                :needNullElement="false"
                :needMultipleSelect="true"
                :defaultSelectName="``"
                :selectedArray="editedItemLocal.set_uploading_geography_ids"
                @set="setUploadingGeography"
              ></tsoft-select-of-properties>

              <div class="region-buttons">
                <button
                  v-for="(countries, region) in regions"
                  :key="region"
                  class="btn btn-outline-secondary btn-sm mr-1"
                  @click.prevent="selectRegionCountries(countries, 'set_uploading_geography_ids')"
                >
                  {{ region }}
                </button>
              </div>              
            </div>
            <div class="form-group col-md-6 corrected-multiselect__tags">
              <label for="set_unloading_geography_ids">Страны разгрузки</label>
              <tsoft-select-of-properties
                :key="`set_unloading_geography_ids_${refreshers['set_unloading_geography_ids']}`"
                :reference_id="20"
                :needNullElement="false"
                :needMultipleSelect="true"
                :defaultSelectName="``"
                :selectedArray="editedItemLocal.set_unloading_geography_ids"
                @set="setUnloadingGeography"
              ></tsoft-select-of-properties>

              <div class="region-buttons">
                <button
                  v-for="(countries, region) in regions"
                  :key="region"
                  class="btn btn-outline-secondary btn-sm mr-1"
                  @click.prevent="selectRegionCountries(countries, 'set_unloading_geography_ids')"
                >
                  {{ region }}
                </button>
              </div>              
            </div>
            <div class="form-group col-md-6 corrected-multiselect__tags">
              <label for="set_transit_directions_ids">Транзит</label>
              <tsoft-select-of-properties
                key="set_transit_directions_ids"
                :reference_id="85"
                :needNullElement="false"
                :needMultipleSelect="true"
                :defaultSelectName="``"
                :selectedArray="editedItemLocal.set_transit_directions_ids"
                @set="setTransitDirections"
              ></tsoft-select-of-properties>
            </div>
            <div class="form-group col-md-6 corrected-multiselect__tags">
              <label for="set_rf_directions_ids">Направления (относительно РФ)</label>
              <tsoft-select-of-properties
                key="set_rf_directions_ids"
                :reference_id="84"
                :needNullElement="false"
                :needMultipleSelect="true"
                :defaultSelectName="``"
                :selectedArray="editedItemLocal.set_rf_directions_ids"
                @set="setRfDirections"
              ></tsoft-select-of-properties>
            </div>
          </div>
        </template>
        
        <h5 class="my-4">Дополнительные данные</h5>
        <div class="form-row">
          <div class="form-group col-md-4">
            <label for="inputMailsCompany">Почта</label>
            <input v-model="editedItemLocal.emails" type="email" class="form-control" id="inputMailsCompany">
          </div>
          <div class="form-group col-md-4" v-if="foreignСompany">
            <label for="reference_property_country_id">Страна</label>
            <tsoft-select-of-properties
              :reference_id="20"
              :needNullElement="false"
              :needMultipleSelect="false"
              :defaultSelectName="`Выберите страну`"
              :internalSearch="false"
              :selected="editedItemLocal.reference_property_country_id"
              @set="setCountryCompany"
            ></tsoft-select-of-properties>
          </div>
          <div class="form-group col-md-4">
            <label for="inputSiteCompany">Сайт</label>
            <input v-model="editedItemLocal.website" type="text" class="form-control" id="inputSiteCompany">
          </div>
          <div class="form-group col-md-4">
            <label for="inputPhonesCompany">Телефон(ы)</label>
            <input v-model="editedItemLocal.phones" type="text" class="form-control" id="inputPhonesCompany">
          </div>
          <div class="form-group col-md-4" v-if="!isAgent">
            <label>Родительская компания</label>
            <tsoft-select-company
              :needNullElement="true"
              :selected="editedItemLocal.parent_id"
              :selectedCompany="editedItemLocal.parent_company"
              :hotUpdate="false"
              @set="setParentOfCompany"
            ></tsoft-select-company>
          </div>
        </div>
        <template v-if="!editedItemLocal.is_transport_company && !isAgent">
          <div class="form-row">
            <div class="form-group col-md-6">
                <label for="percent_of_mp_to_calc">Процент маржинальной прибыли, идущий в расчеты</label>
                <b-form-input 
                    v-model="editedItemLocal.percent_of_mp_to_calc" 
                    type="number" 
                    class="form-control" 
                    placeholder="0-100"
                    id="percent_of_mp_to_calc"
                    min="0" 
                    max="100" 
                    step="1"
                    style="width: 150px;"
                ></b-form-input>
            </div>

            <div class="form-group col-md-6" v-if="!isAgent">
                <label for="external_sales_manager_name">Если клиента привёл сотрудник без учётной записи</label>
                <input 
                  v-model="editedItemLocal.external_sales_manager_name" 
                  type="text" 
                  class="form-control" 
                  placeholder="Например, Михаил Фомичев / 5000 рублей / 01.03.2025"
                  id="external_sales_manager_name"
                >
            </div>
  
            <div class="form-group col-md-6" style="display: none">
              <label for="motivation_only_escort">Мотивация</label>
              <b-form-checkbox
                name="check-button"
                class="mb-1"
                v-model="editedItemLocal.motivation_only_escort"
                switch
              >
                Считать только сопровождение
              </b-form-checkbox>
            </div>			
            <div class="form-group col-md-6" style="display: none">
              <label for="motivation_block_all">Мотивация</label>
              <b-form-checkbox
                name="check-button"
                class="mb-1"
                v-model="editedItemLocal.motivation_block_all"
                switch
              >
                Полная блокировка
              </b-form-checkbox>
            </div>
          </div>
        </template>
        <template v-if="editedItemLocal.is_transport_company && onlyForHeads()">
          <h5 class="my-4">Проверка компании</h5>
          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="checked_id">Статус проверки</label>
              <tsoft-select-of-properties
                :reference_id="44"
                :needNullElement="false"
                :needMultipleSelect="false"
                :defaultSelectName="`Статус проверки`"
                :internalSearch="false"
                :selected="editedItemLocal.checked_id"
                @set="setStatusOfChecking"
              ></tsoft-select-of-properties>
            </div>
          </div>
        </template>
      </form>
    </div>

    <div class="sticky-save-block mt-auto p-3">
      <div class="d-flex">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script>
import CompanyClientStatusField from '@components/companies/CompanyClientStatusField.vue';
import { mapGetters } from 'vuex';
import { API_COMPANY } from '@/constants';

import {
  typeOfCompany,
  salesStatusListOfCompany,  
  maxCharsLimit,
  defaultDataItems,
  typeOfTransportCompanyList,
  validateAndReplaceQuotes,
} from '@/mixins';

import { regionHelpers } from '@/mixins/regionHelpers';

export default {
  components: { CompanyClientStatusField },
  props: {
    editedItem: { type: Object, default: () => {} },
  },
  mixins: [
    typeOfCompany,
    salesStatusListOfCompany,
    maxCharsLimit,
    defaultDataItems,
    typeOfTransportCompanyList,
    validateAndReplaceQuotes,
    regionHelpers
  ],
  data() {
    return {
      editedItemLocal: JSON.parse(JSON.stringify(this.editedItem)),
      tableApiUrl: API_COMPANY,
      foreignСompany: false,
      maskPhone: '',
      selectedCompany: {
          value: '',
          data: {
              inn: '',
              kpp: '',
              ogrn: '',
              type: '',
              management: {
                  name: '',
                  post: ''
              },
              address: {
                  value: ''
              },
          }
      },
      companies: [],
      seasonable: [],
    }
  },
  watch: {
    editedItemLocal: {
      handler(value) {
        this.onItemEditModalCallback()

        if (!this.validateCompanyName.valid) {
          this.makeToast('danger', 'Ошибка в заполнении формы')
          this.$emit('change-company', 'error')
        } else {
          this.$emit('change-company', value)
        }
      },
      deep: true,
      immediate: true,
    },
    selectedCompany: function(){
      this.editedItemLocal.name = this.selectedCompany.value;
      this.editedItemLocal.type = this.selectedCompany.data.type;
      this.editedItemLocal.inn = this.selectedCompany.data.inn;
      this.editedItemLocal.kpp = this.selectedCompany.data.kpp;
      this.editedItemLocal.ogrn = this.selectedCompany.data.ogrn;
      this.editedItemLocal.address = this.selectedCompany.data.address ? this.selectedCompany.data.address.value : '';
      this.editedItemLocal.director = this.selectedCompany.data.management ? this.selectedCompany.data.management.name : '';
      this.editedItemLocal.type_director = this.selectedCompany.data.management ? this.selectedCompany.data.management.post : '';
      this.editedItemLocal.parent_id = this.selectedCompany.data.parent_id;
      this.editedItemLocal.parent_company = this.selectedCompany.data.parent_company;
      this.editedItemLocal.seasonable = null;
    },
    foreignСompany: function(value){
      if (value == true){
        this.editedItemLocal.reference_property_country_id = '';
        this.editedItemLocal.in_russia = 0;
        this.editedItemLocal.kpp = '';
        this.editedItemLocal.ogrn = '';
      } else {
        this.editedItemLocal.in_russia = 1;
        this.editedItemLocal.reference_property_country_id = 209;
      }
    },
    'editedItemLocal.name': function (name) {
      this.editedItemLocal.name = this.replacementQuotes(name);
      this.validateQuotesText(name);
    },
    'editedItemLocal.reference_friend_type_id': function (id) {
      if (id !== 412) {
        this.editedItemLocal.is_transport_company = false;
      }
    },
  },
  computed: {
    ...mapGetters("auth", ["currentUser"]),
    
    isAgent() {
      return this.currentUser.role.includes("agent");
    }
  },
  mounted() {
    this.getConst();
  },
  methods: {
    getConst() {
      api.call('get', `${this.tableApiUrl}/get-const`, this.editedItemLocal).then(({data}) => {
        this.seasonable = data.seasonable ?? [];
      })
    },
    onItemEditModalCallback() {
      this.editedItemLocal.motivation_block_all = (this.editedItemLocal.motivation_block_all == 1) ? true : false
      this.editedItemLocal.motivation_only_escort = (this.editedItemLocal.motivation_only_escort == 1) ? true : false
      this.editedItemLocal.is_transport_company = (this.editedItemLocal.is_transport_company == 1) ? true : false
      this.editedItemLocal.is_b2c_rezident = (this.editedItemLocal.is_b2c_rezident == 1) ? true : false
      this.editedItemLocal.b2c_alias = this.editedItemLocal.b2c_alias || ''
    },
    setStatusOfCompany(value) {
      this.editedItemLocal.reference_company_status_id = value
    },
    setRiskOfCompany(value) {
      this.$set(this.editedItemLocal, 'is_at_risk', !!value)
    },
    setDeclineTypeOfCompany(value) {
      this.editedItemLocal.decline_type_reference_property_id = value
    },
    setCountryCompany(value) {
      this.editedItemLocal.reference_property_country_id = value
    },
    setSourceOfCompany(value) {
      this.editedItemLocal.reference_sources_id = value
    },
    setParentOfCompany(value) {
      this.editedItemLocal.parent_id = value
    },
    setFriendTypeOfCompany(value) {
      this.editedItemLocal.reference_friend_type_id = value
    },
    setSalesManagerOfCompany(value) {
      this.editedItemLocal.sales_manager_user_id = value
    },
    setTEOManagerOfCompany(value) {
      this.editedItemLocal.teo_manager_user_id = value
    },
    setTOManagerOfCompany(value) {
      this.editedItemLocal.to_manager_user_id = value
    },
    setServicesOfCompany(value) {
      this.editedItemLocal.set_services_ids = value
    },
    setSpecialFeaturesOfCompany(value) {
      this.editedItemLocal.set_special_features_ids = value
    },
    setCountriesOfBranchesOfCompany(value) {
      this.editedItemLocal.set_countries_of_branches_ids = value
    },
    setCountriesOfRollingStocksOfCompany(value) {
      this.editedItemLocal.set_countries_of_rolling_stock_ids = value
    },
    setStatusOfChecking(value) {
      this.editedItemLocal.checked_id = value
    },
    addClient() {
      this.editedItemLocal.clients.push({});
    },
    removeClient(index) {
      this.editedItemLocal.clients.splice(index, 1);
    },
    setClientOfCompany(index, client_id) {
      this.$set(this.editedItemLocal.clients, index, { id: client_id });
    },
    setUploadingGeography(value) {
      this.editedItemLocal.set_uploading_geography_ids = value
    },
    setUnloadingGeography(value) {
      this.editedItemLocal.set_unloading_geography_ids = value
    },
    setTransitDirections(value) {
      this.editedItemLocal.set_transit_directions_ids = value
    },
    setRfDirections(value) {
      this.editedItemLocal.set_rf_directions_ids = value
    },
    onlyForHeads() {
        if (this.currentUser.role && (this.currentUser.role.includes("administrator") ||
            this.currentUser.role.includes("president"))) {
            return true
        }
        return false
    },
  }
}
</script>

<style scoped>
.sticky-save-block {
  position: sticky;
  bottom: 0;
  right: 0;
  text-align: right;
  width: 100%;
  background: #dbdbdba6;
}
.custom-select {
  line-height: 32px;
  height: 50px;
  border-radius: 1px;
}
</style>
